import { render, staticRenderFns } from "./RevisionHistory.vue?vue&type=template&id=33ffd3b6"
import script from "./RevisionHistory.vue?vue&type=script&lang=ts"
export * from "./RevisionHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports